// Generated by genversion.
export const version = '7.1.1';
//# sourceMappingURL=version.js.map